﻿import { createI18n } from 'vue-i18n';

export default createI18n({
    locale: document.documentElement.lang,
    messages: window.dictionaryItems || []
});
